import {
  Breadcrumb,
  Button,
  Card,
  Col,
  ConfigProvider,
  Dropdown,
  Empty,
  Input,
  Layout,
  message,
  Row,
  Table,
  Tabs,
  Tooltip,
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import OAMSider from '../../oam-sider'
import { Content } from 'antd/lib/layout/layout'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { sendHttpPostRequest } from '@/api/http-request'
import css from './dataset-detail.module.less'
import SearchInput from '@/pages/components/SearchInput/SearchInput'
import GlobalCss from '@/global.module.less'
import type { MenuProps } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import { formatBytesSize } from '@/pages/common/utils/util'
import DatasetUploadFileModal from '../components/DatasetUploadFileModal/DatasetUploadFileModal'
import { FileList } from './FileList'
import PublicDatasetFormModal from '../components/PublicDatasetFormModal/PublicDatasetFormModal'

function DatasetDetailPage() {
  const params = useParams()
  const datasetId = params['id']
  const state: any = useLocation()?.state
  const taskType = state?.type && state?.type == 'task'
  const history = useHistory()
  const [datasetInfo, setDatasetInfo] = useState<any>()
  const [editModalVis, setEditModalVis] = useState(false)

  const getDatasetDetail = () => {
    let data = {
      dataset_id: datasetId,
    }
    sendHttpPostRequest('dataset/api/oam_get_dataset_by_id/', data, (res) => {
      if (res.code == 0) {
        setDatasetInfo(res.query_info)
      }
      if (res.code == -100) {
        message.error(res.message)
      }
    })
  }

  useEffect(() => {
    getDatasetDetail()
    return () => {}
  }, [])

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={'dataset'} openKeys={[]}></OAMSider>
      <Layout style={{ backgroundColor: '#f9f9f9', padding: '20px 30px' }}>
        <Breadcrumb style={{ marginBottom: '20px' }}>
          {taskType ? (
            <Breadcrumb.Item
              className={GlobalCss.link}
              onClick={() =>
                history.push('/oam_dataset_list', { type: 'task' })
              }
            >
              {' '}
              任务数据集
            </Breadcrumb.Item>
          ) : (
            <Breadcrumb.Item
              className={GlobalCss.link}
              onClick={() =>
                history.push('/oam_dataset_list', { type: 'public' })
              }
            >
              {' '}
              公共数据集
            </Breadcrumb.Item>
          )}
          <Breadcrumb.Item>数据集详情</Breadcrumb.Item>
        </Breadcrumb>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
          }}
        >
          <Card
            style={{ height: '100%' }}
            title={
              <Row align={'middle'} justify={'start'} style={{ gap: '10px' }}>
                <Col>{datasetInfo?.title}</Col>
                {taskType ? (
                  ''
                ) : (
                  <Col>
                    <div
                      className={GlobalCss.btnBox}
                      onClick={() => setEditModalVis(true)}
                    >
                      <span className="iconfont icon-bianji"></span>
                    </div>
                  </Col>
                )}
              </Row>
            }
          >
            <div className={css.headerFlex}>
              <Row align={'middle'}>
                <Col>创建时间：</Col>
                <Col>{datasetInfo?.create_time}</Col>
              </Row>
              <Row align={'middle'}>
                <Col>描述：</Col>
                <Col>{datasetInfo?.description}</Col>
              </Row>
            </div>

            <Tabs
              items={[
                {
                  label: '数据文件',
                  key: 'data_file',
                  children: datasetInfo && (
                    <FileList datasetInfo={datasetInfo} dataset_id={datasetInfo?.id} />
                  ),
                },
              ]}
            ></Tabs>
          </Card>
        </Content>
        {datasetInfo && (
          <PublicDatasetFormModal
            mode={'edit'}
            open={editModalVis}
            setOpen={setEditModalVis}
            actionCallback={getDatasetDetail}
            actionDataset={datasetInfo}
          />
        )}
      </Layout>
    </Layout>
  )
}

export default DatasetDetailPage
